/*
 * @Author: liyihui
 * @Date:
 * @description: 工具类，日期、时间、数字、正则校验、pageLoading
 * @Last Modified by:
 * @Last Modified time:
 */
import api from '@/api';


/**
 * 开启接口调用时页面pageLoading和关闭
 * @return element的组件对象
 */
import { Loading } from 'element-ui';
var pageLoading = null;
export function openLoading() {
	if (pageLoading === null) {
		pageLoading = Loading.service({
			lock: true, // 是否锁屏
			text: '正在加载...',
			body: true,
			customClass: 'mask',
			background: 'rgba(255, 255, 255, 0.7)',
		});
	}
	// if (flag) setTimeout(function() {
	// 	// 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
	// 	pageLoading.close(); // 关闭遮罩层
	// }, 5000);
	return pageLoading;
}
export function closeLoading() {
	pageLoading.close();
	pageLoading = null;
	return pageLoading;
}

/**
 * 字段匹配，根据要匹配对象中的一个字段匹配对象数组中的某一对象，获得它的指定字段属性内容
 * @param {*} matchData 要匹配的字段所在的对象
 * @param {*} matchList 要匹配的数组，对象数组，匹配对象中的字段
 * @param {*} dataName matchData中进行匹配的字段名
 * @param {*} newName 匹配成功后给matchData中赋值的字段名
 * @return 无
 */
export function matchDictionry(matchData, matchList, dataName, newName) {
	for (let item of matchList) {
		if (matchData[dataName] === item.value) matchData[newName] = item.label;
	}
}

/**
 * 导出接口，北京后台团队的导出使用的导出通用方法
 * @param {*} funcAddress 下载请求地址
 * @param {*} funcData 下载请求主体参数
 * @return 
 */
import { getToken } from '@/utils/auth';
export function downloadFile( funcAddress, funcData,name) {
	let downArry = setQueryConfig(funcData);
	var xhr = new XMLHttpRequest();
	var formData = new FormData();
	xhr.open('get', funcAddress + `?` + downArry);
	xhr.setRequestHeader('Authorization', getToken());
	xhr.responseType = 'blob';
	xhr.onload = function (e) {
		if (this.status == 200) {
			var blob = this.response;
			var filename = name ? name : xhr.getResponseHeader("Content-Disposition").split("=")[1];
			filename = decodeURI(filename);
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename);
			} else {
				var a = document.createElement('a');
				var url = createObjectURL(blob);
				a.href = url;
				a.download = filename;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove();
			}

		}
	};
	xhr.send(formData);
}

function createObjectURL(object) {
	return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
}
function setQueryConfig(array) {
	var _str = "";
	for (var o in array) {
		if (array[o] != -1) {
			_str += o + "=" + array[o] + "&";
		}
	}
	var _str = _str.substring(0, _str.length - 1);
	return _str;
}
// 音频下载
export function downloadAudio(filePath) {
	
	fetch(filePath).then(res => res.blob()).then(blob => {
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style.display = 'none'
        // 使用获取到的blob对象创建的url
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // 指定下载的文件名
        a.download = '语音音频.mp3'
        a.click()
        document.body.removeChild(a)
        // 移除blob对象的url
        window.URL.revokeObjectURL(url)
      })
}


/**
 * 将时间戳转成年月日时分秒，若未传参，获取当前时间的年月日时分秒
 * @param {*} date 时间戳
 * @return 年月日时分秒字符串
 */
export function formatTime(date = null) {
	let myDate = new Date(date);
	let Year = myDate.getFullYear(); // 获取年
	let Month = myDate.getMonth() + 1; // 获取月，默认从0开始，所以要加一
	let Dates = myDate.getDate(); // 获取日
	let Hour = myDate.getHours(); // 获取小时
	let Minute = myDate.getMinutes(); // 获取分
	let Seconds = myDate.getSeconds(); // 获取秒
	// 当数值为个数时，在前面加0
	if (Month < 10) Month = '0' + Month;
	if (Dates < 10) Dates = '0' + Dates;
	if (Hour < 10) Hour = '0' + Hour;
	if (Minute < 10) Minute = '0' + Minute;
	if (Seconds < 10) Seconds = '0' + Seconds;

	return Year + '-' + Month + '-' + Dates + ' ' + Hour + ':' + Minute + ':' + Seconds;
}
/**
 * 将时间戳转成年月日，若未传参，获取当前时间的年月日
 * @param {*} date 时间戳
 * @return 年月日字符串
 */
export function formatDate(date = null) {
	var myDate = new Date(date);
	var year = myDate.getFullYear();
	var month = myDate.getMonth() + 1;
	var dates = myDate.getDate();
	if (month < 10) month = '0' + month;
	if (dates < 10) dates = '0' + dates;

	return year + '-' + month + '-' + dates;
}
/**
 * 将时间戳转成年月，若未传参，获取当前时间的年月
 * @param {*} date 时间戳
 * @return 年月字符串
 */
export function formatMonth(date = null) {
	var myDate = new Date(date);
	var year = myDate.getFullYear();
	var month = myDate.getMonth() + 1;
	if (month < 10) month = '0' + month;

	return year + '-' + month;
}
/**
 * 数字转成三位一逗号的字符串，保留几位小数
 * @param {*} num 要保留的小数位数
 * @return 带逗号数字字符串
 */
export function toThousands(num = 0) {
	num = num.toString();
	let number = 0, floatNum = '', intNum = '';
	// 判断是否有小数位，有则截取小数点后的数字
	if (num.indexOf('.') > 0) {
		number = num.indexOf('.'); // 获取小数点出现的位置
		floatNum = num.substr(number); // 截取arr.substr(form, length)
		intNum = num.substring(0, number); // 截取arr.substring(start, end)
	} else {
		intNum = num;
	}
	let result = [], counter = 0;
	intNum = intNum.split('');
	// 利用3的倍数，向数组插入','
	for (let i = intNum.length - 1; i >= 0; i--) {
		counter++;
		result.unshift(intNum[i]);
		if (!(counter % 3) && i != 0) {
			result.unshift(',');
		}
	}
	return result.join('') + floatNum || '';
}

/**
 * base64图转blob
 * @param {String} code base64字符串
 * @return Blob对象
 */
export function base64ToBlob(code) {
	let parts = code.split(';base64,');
	let contentType = parts[0].split(':')[1];
	let raw = window.atob(parts[1]);
	let rawLength = raw.length;

	let uInt8Array = new Uint8Array(rawLength);

	for (let i = 0; i < rawLength; ++i) {
		uInt8Array[i] = raw.charCodeAt(i);
	}
	return new Blob([uInt8Array], { type: contentType });
}

//将日期转成字符串 油商使用
export function timeStamp(date) {
	if (date != '' && date != undefined) {
		var date = date.substring(0, 19);
		var date = date.replace(/-/g, '/');
		var timestamp = new Date(date).getTime();
	} else {
		var timestamp = '';
	}
	return timestamp;
}


// 坐标
var XPI = 3.14159265358979324 * 3000.0 / 180.0;
var PI = 3.1415926535897932384626;
// var a = 6378245.0;
var EE = 0.00669342162296594323;
/**
 * 火星坐标系 (GCJ-02) 与百度坐标系 (BD-09) 的转换
 * 即谷歌、高德 转 百度
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function gcj02tobd09(lng, lat) {
	var lat = +lat;
	var lng = +lng;
	var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * XPI);
	var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * XPI);
	var bd_lng = z * Math.cos(theta) + 0.0065;
	var bd_lat = z * Math.sin(theta) + 0.006;
	// return [bd_lng, bd_lat];
	return { lng: bd_lng, lat: bd_lat };
};
/**
 * GCJ02 转换为 WGS84
 * @param lng
 * @param lat
 * @returns {*[]}
 */
export function gcj02towgs84(lng, lat) {
	var lat = +lat;
	var lng = +lng;
	if (out_of_china(lng, lat)) {
		return [lng, lat];
	} else {
		var dlat = transformlat(lng - 105.0, lat - 35.0);
		var dlng = transformlng(lng - 105.0, lat - 35.0);
		var radlat = (lat / 180.0) * PI;
		var magic = Math.sin(radlat);
		magic = 1 - EE * magic * magic;
		var sqrtmagic = Math.sqrt(magic);
		dlat = (dlat * 180.0) / (((a * (1 - EE)) / (magic * sqrtmagic)) * PI);
		dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
		var mglat = lat + dlat;
		var mglng = lng + dlng;
		return [lng * 2 - mglng, lat * 2 - mglat];
	}
};
var transformlat = function transformlat(lng, lat) {
	var lat = +lat;
	var lng = +lng;
	var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
	ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
	ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
	ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
	return ret;
};

var transformlng = function transformlng(lng, lat) {
	var lat = +lat;
	var lng = +lng;
	var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
	ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
	ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
	ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
	return ret;
};
/**
 * 判断是否在国内，不在国内则不做偏移
 * @param lng
 * @param lat
 * @returns {boolean}
 */
var out_of_china = function out_of_china(lng, lat) {
	var lat = +lat;
	var lng = +lng;
	// 纬度3.86~53.55,经度73.66~135.05
	return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
};



// WEBPACK FOOTER //
// ./src/utils/tools.js